import ApiUrl from "../../../configTools/api";
// Guarantees the callback fires exactly once with an array, even on failure - the page
// clears its loading flag inside it, so a dropped request must not leave a shimmer spinning.
import { apiGetList } from "../../../configTools/apiGet";

const Get = (setValues) => {
    apiGetList(ApiUrl.Admin_Subscriber, (list, body)=>{
        setValues(list);
    });
}


const Functions = {Get};
export default Functions;